import Progress from './progress';
import { withInstall } from '../_util/type';
export default withInstall(Progress);
